import * as React from 'react'

function SvgCommentIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M14.055 14.273C14 14.38 14 14.52 14 14.8v.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h10.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C26 15.62 26 15.48 26 15.2v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C25.62 14 25.48 14 25.2 14H14.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218ZM14 18.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C14.38 18 14.52 18 14.8 18h6.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C21.62 20 21.48 20 21.2 20h-6.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C14 19.62 14 19.48 14 19.2v-.4ZM24.055 18.273C24 18.38 24 18.52 24 18.8v.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C26 19.62 26 19.48 26 19.2v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C25.62 18 25.48 18 25.2 18h-.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.564 12.184a4 4 0 0 0-1.748-1.748C26.96 10 25.84 10 23.6 10h-7.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C10 13.04 10 14.16 10 16.4v12.186c0 .89 1.077 1.337 1.707.707l3.298-3.299c.412.006.873.006 1.395.006h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C30 22.96 30 21.84 30 19.6v-3.2c0-2.24 0-3.36-.436-4.216Zm-14.532 11.81-.844-.01L12 26.171V16.4c0-1.153.002-1.898.048-2.464.044-.544.12-.745.17-.844a2 2 0 0 1 .874-.874c.099-.05.3-.126.844-.17.566-.046 1.31-.048 2.464-.048h7.2c1.153 0 1.898.002 2.464.048.544.044.745.12.844.17a2 2 0 0 1 .874.874c.05.099.126.3.17.844.046.566.048 1.31.048 2.464v3.2c0 1.153-.002 1.898-.048 2.464-.044.544-.12.745-.17.844a2 2 0 0 1-.874.874c-.099.05-.3.126-.844.17-.566.046-1.31.048-2.464.048h-7.2c-.526 0-.973 0-1.368-.005Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgCommentIcon
